// facebookClientUtils.js
export function getMetaCookies() {
  const cookies = document.cookie.split(';').map(c => c.trim());
  
  const getCookieValue = (name) => {
    const cookie = cookies.find(c => c.startsWith(`${name}=`));
    return cookie ? cookie.split('=')[1] : null;
  };

  const fbp = getCookieValue('_fbp');
  const fbc = getCookieValue('_fbc');
  const userAgent = navigator.userAgent;

  return { fbp, fbc, userAgent };
}
